import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
var _excluded = ["column", "options", "placeholder", "className", "isCreatable", "optionWithTooltip"],
    _excluded2 = ["column"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CreatableSelect } from 'src/components/common/Form/CreatableSelect';
import { Select } from 'src/components/common/Form/Select';
import { jsx as _jsx } from "react/jsx-runtime";

var getOptions = function getOptions(t, list) {
  var options = list.every(function (val) {
    return typeof val === 'string';
  }) ? list.filter(function (val) {
    return val;
  }).map(function (p) {
    return {
      label: p,
      value: p
    };
  }) : list;
  return [{
    label: t('common:normal.all', '全部'),
    value: ''
  }].concat(_toConsumableArray(options));
};

export function SelectFilter(_ref) {
  var column = _ref.column,
      options = _ref.options,
      placeholder = _ref.placeholder,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'w-24' : _ref$className,
      _ref$isCreatable = _ref.isCreatable,
      isCreatable = _ref$isCreatable === void 0 ? true : _ref$isCreatable,
      _ref$optionWithToolti = _ref.optionWithTooltip,
      optionWithTooltip = _ref$optionWithToolti === void 0 ? false : _ref$optionWithToolti,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var SelectComp = isCreatable ? CreatableSelect : Select;
  var formattedOptions = useMemo(function () {
    return getOptions(t, options);
  }, [options, t]);
  var value = column.getFilterValue();
  var selectedOption = formattedOptions.find(function (option) {
    return option.value === value;
  });
  return /*#__PURE__*/_jsx(SelectComp, _objectSpread(_objectSpread({
    className: className,
    onChange: function onChange(_ref2) {
      var value = _ref2.value;
      column.setFilterValue(value || '');
    },
    placeholder: placeholder || t('common:normal.searchKey', '搜尋關鍵字'),
    options: formattedOptions,
    value: selectedOption,
    optionWithTooltip: optionWithTooltip
  }, props), {}, {
    e2eid: "Filter_SelectFilter_SelectComp"
  }));
}
export function FacetSelectFilter(_ref3) {
  var column = _ref3.column,
      props = _objectWithoutProperties(_ref3, _excluded2);

  var options = useMemo(function () {
    return Array.from(column.getFacetedUniqueValues().keys()).sort().slice(0, 5000);
  }, [column.getFacetedUniqueValues()]);
  var value = column.getFilterValue();
  var selectedOption = options.find(function (option) {
    return option.value === value;
  });
  return /*#__PURE__*/_jsx(SelectFilter, _objectSpread(_objectSpread({
    column: column,
    options: options,
    value: selectedOption
  }, props), {}, {
    e2eid: "Filter_SelectFilter_SelectFilter"
  }));
}